module.exports = __webpack_public_path__ + "static/media/starling-bank.faf719be.svg";